export default "__VITE_ASSET__8e273df1__"